import Carousel from './Carousel.svelte';
window.addEventListener('load', () => {
	document.querySelectorAll('*[data-svelte-carousel]').forEach(el => {
		if (el.getAttribute('data-carousel-initialized') == 'true') return;
		
		el.setAttribute('data-carousel-initialized', 'true');
		const children = Array.from(el.children).map(c => c.innerHTML);
		el.innerHTML = '';
		const classes = el.getAttribute('class');
		el.setAttribute('class', '');
		el.setAttribute('data-svelte-carousel', null);
		new Carousel({
			target: el,
			props: {
				children,
				classes
			}
		});
	});
});
window.addEventListener('product-recommendations-done', () => {
	document.querySelectorAll('*[data-svelte-carousel]').forEach(el => {
		// console.log('recommendations-done');
		if (el.getAttribute('data-carousel-initialized') == 'true') return;
		
		el.setAttribute('data-carousel-initialized', 'true');
		const children = Array.from(el.children).map(c => c.innerHTML);
		el.innerHTML = '';
		const classes = el.getAttribute('class');
		el.setAttribute('class', '');
		el.setAttribute('data-svelte-carousel', null);
		new Carousel({
			target: el,
			props: {
				children,
				classes
			}
		});
	});
});